import React, { useEffect, useState } from "react";
import "./random.css";
import { Link } from "react-router-dom";

const RandomFacts = ({ selectedTool, setSelectedTool }) => {
  useEffect(() => {
    setSelectedTool("/random-facts");
  }, []);

  const [currentPage, setCurrentPage] = useState(0);

  const pages = [
    {
      question: "1. Did you know?",
      answer:
        "Did you know your baby’s sense of hearing starts developing as early as 18 weeks in the womb? They can already hear your voice and will recognise it right after birth! So, feel free to talk to your bump! Whether it’s a sweet lullaby, a funny story, or just chatting about your day, your little one is already listening and bonding with you! Talking to your baby while they’re still in the womb is more than just a sweet gesture, it’s a way of creating a connection and forming early bonds. Even though they can’t respond or communicate back, babies in the womb can pick up on the rhythm and melody of your voice. By the time they're born, they will likely recognize your voice, which can be soothing for them and help ease the transition to the outside world.",
    },
    {
      question: "2. Pregnancy glow?",
      answer:
        "Pregnancy brings out a unique kind of glow. As hormones fluctuate and your skin stretches, many women experience a natural radiance that seems to appear out of nowhere. Increased blood flow and higher oestrogen levels give your skin a fresh, dewy look, often making it seem like you’re glowing from the inside out. It’s nature’s way of enhancing your beauty while you create life—a luminous shine that leaves you feeling as radiant as the little one growing inside you. It’s also possible that the pregnancy glow is partially psychological; when you’re carrying new life, many women feel more beautiful and empowered, which can boost their overall confidence and energy. The glow isn’t just a physical phenomenon; it’s also tied to the deep emotional experience of pregnancy, which makes you feel radiant from the inside out.",
    },
    {
      question: "3. From Pear to Watermelon!",
      answer:
        "During pregnancy, the uterus increases its size by about 500 times. The muscles and tissues in the uterus are stretchy enough to allow it to grow rapidly. The uterine walls are made of smooth muscle, which helps them stretch without tearing. That's some serious stretching! As the pregnancy progresses, the muscle fibres in the uterus elongate and become more organised, allowing for efficient stretching. In addition to the smooth muscle, the uterine wall also contains connective tissue that provides support and flexibility. The body produces relaxin, a hormone that helps loosen the ligaments and joints in preparation for labour and delivery, which also contributes to the uterus’ ability to stretch.",
    },
    {
      question: "4. Blood Volume Increase:",
      answer:
        "During pregnancy, your blood volume expands by 40%, working hard to nourish both you and your baby. This increased blood flow helps deliver more oxygen and nutrients, supporting your baby’s growth while keeping you energised. It’s like your body creates a supercharged circulation system to make sure everything runs smoothly. Plus, this extra blood can contribute to that glowing complexion many expectant mothers experience!",
    },
    {
      question: "5. Pregnancy Brain:",
      answer:
        "Pregnancy is a real phenomenon! As hormones fluctuate and your body undergoes changes, it’s common to experience some forgetfulness or brain fog. It’s not that you're losing your sharpness—it's just that your body is focused on growing a tiny human, which can leave you feeling a bit scatterbrained. From forgetting simple tasks to misplacing things, it’s all part of the experience. But don't worry—it’s temporary! Pregnancy brain may make you feel a little off, but once your baby is here, your mind will snap back into focus.",
    },
    {
      question: "6. Pregnancy Cravings:",
      answer:
        " Pregnancy cravings are a well-known phenomenon, with many women experiencing intense desires for specific foods like pickles, chocolate, or even more unusual items like ice, chalk, or even dirt. Some experts believe that the cravings might be linked to hormonal changes that alter taste and smell, making certain foods more appealing. Others suggest that cravings may be the body's way of compensating for nutritional deficiencies. Emotional factors and stress may also play a role in these cravings, as the pregnancy journey can bring about sensitivities and desires for comfort foods.",
    },
    {
      question: "7. Breastfeeding :",
      answer:
        " Breastfeeding is not only a beautiful bonding experience between a mother and her baby, but it also has some significant physical benefits for the mother, including the potential for calorie burning. On average, breastfeeding can burn between 300 to 500 calories a day, depending on factors like how frequently and how long the mother nurses. This calorie expenditure is due to the energy required to produce milk and feed the baby, both of which demand a lot of energy from the mother’s body. The body uses energy to produce milk. The mammary glands (in the breasts) require extra calories to convert the nutrients in the mother’s body into milk for her baby.",
    },
    {
      question: "8. After birth :",
      answer:
        "The uterus undergoes a significant process known as involution, where it shrinks back to its pre-pregnancy size. During pregnancy, the uterus expands greatly to accommodate the growing baby, and after delivery, it needs to return to its original size, which typically takes about 6-8 weeks. This process is necessary for the body to heal and recover from childbirth. The cramping that many women experience during this time is called 'afterpains.' These pains are caused by the contractions of the uterus as it works to shrink back to its original size. The contractions are triggered by the hormone oxytocin, which helps the uterus contract and heal",
    },
    {
      question: "9. Baby Blues : The 'baby blues'",
      answer:
        "refers to a common, temporary emotional state that many new mothers experience in the first few weeks after childbirth. It’s characterized by feelings of sadness, mood swings, irritability, crying, and anxiety. These feelings usually begin within the first few days after delivery and can last up to two weeks. It’s often triggered by the dramatic hormonal shifts that happen after childbirth, as well as the physical and emotional adjustments to motherhood. During pregnancy, a woman’s body experiences high levels of hormones like estrogen and progesterone. After delivery, these hormone levels drop rapidly, which can affect mood and emotional well-being. The physical recovery from childbirth, lack of sleep, and the demands of caring for a newborn can also contribute to feelings of overwhelm and exhaustion.",
    },
    {
      question: "10. Fourth Trimester :",
      answer:
        "The fourth trimester refers to the first three months after birth, and it's a concept that highlights just how much adjustment both the baby and the mother go through during this period. While pregnancy is often broken down into three trimesters, the fourth trimester is crucial for both physical and emotional healing and for the baby’s transition from the womb to the outside world. Babies are still very much in need of the safety and comfort they had in the womb, and they’re learning to navigate the outside world. The first few months are full of physical changes like developing better control over their head and neck, starting to gain weight, and becoming more aware of their surroundings. ",
    },
  ];

  const nextPage = () => {
    if (currentPage < pages.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="random-basee">
      <div className="random-cont">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link
                  to="/"
                  className="breadcrumb-link"
                  onClick={() => setSelectedTool("")}
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">RandomFacts</li>
            </ol>
          </nav>
        </div>

        <h1
          style={{
            textAlign: "center",
            marginBottom: "40px",
            textTransform: "initial",
          }}
        >
          Random Facts
        </h1>
        <div className="cute-book-container">
          <div className="cute-book">
            <div className="spine"></div>
            <div className="pages">
              {pages.map((content, index) => (
                <div
                  key={index}
                  className={`page ${
                    index === currentPage
                      ? "current"
                      : index < currentPage
                      ? "flipped-prev"
                      : "flipped-next"
                  }`}
                >
                  <div className="page-content">
                    <b style={{ marginRight: "15px" }}>{content.question}</b>
                    {content.answer}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="controls">
            <button onClick={prevPage} disabled={currentPage === 0}>
              🡠 Previous
            </button>
            <span className="page-number">
              Page {currentPage + 1} of {pages.length}
            </span>
            <button
              onClick={nextPage}
              disabled={currentPage === pages.length - 1}
            >
              Next 🡢
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RandomFacts;
